module.exports = __webpack_public_path__ + "img/b43843df8922dbce317f97e6dd2eb031.svg";